export function parse<T>(json: string): T {
  return JSON.parse(json) as T;
}
